import request from '@/libs/http/index'
// 获得采购列表
export const purchaseOrderPage = params => {
  return request.get({
    url: `/clinic/purchase-order/page`,
    params,
  })
}
export const purchaseOrderSummary = params => {
  return request.get({
    url: `/clinic/purchase-order/summary`,
    params,
  })
}
// 获得采购单详情
export const purchaseOrderItemSummary = params => {
  return request.get({
    url: `/clinic/purchase-order/item-summary`,
    params,
  })
}
export const purchaseOrderDetail = params => {
  return request.get({
    url: `/clinic/purchase-order/get`,
    params,
  })
}
// 查询库存单据操作记录
export const purchaseOrderOperationLogList = params => {
  return request.get({
    url: `/clinic/stock-order-operation-log/list`,
    params,
  })
}
// 删除采购单
export const purchaseOrderDelete = params => {
  return request.delete({
    url: `/clinic/purchase-order/delete`,
    params,
  })
}

// 创建采购列表
export const purchaseOrderCreate = data => {
  return request.post({
    url: `/clinic/purchase-order/create`,
    data,
  })
}

// 导出采购单列表
export const purchaseOrderPageExport = params => {
  return request.get({
    url: `/clinic/purchase-order/get-export-detail`,
    params,
  })
}

// 导出采购单详情
export const purchaseOrderDetailExport = (params: {
  id: number
  exportType: string
}) => {
  return request.get({
    url: `/clinic/purchase-order/get-export`,
    params,
  })
}

// 获得商城药品列表
export const getProductPage = params => {
  return request.get({
    url: `/clinic/yst/get-product-page`,
    params,
    noErrorTip: true,
  })
}
export const getPayStatus = params => {
  return request.get({
    url: `/clinic/yst/get-pay-status`,
    params,
  })
}

// 预警药品生成采购单
export const warnPurchase = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/warn-purchase`,
    params,
  })
}
